const $ = require('jquery');

/*FADE-IN EFFEKT*/
function isElementFullInViewport(element) {
    var rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}
    
  function callbackFunc() {

    for (var i = 0; i < $('.animate-margin').length; i++) {
        if (isElementFullInViewport($('.animate-margin')[i])) {
            $('.animate-margin')[i].classList.add("translate-left");
        }
    }

    for (var i = 0; i < $('.slider-left-border').length; i++) {
        if (isElementFullInViewport($('.slider-left-border')[i])) {
            $('.slider-left-border')[i].classList.add("white-border");
        }
    }

    for (var i = 0; i < $('.slider-right-border').length; i++) {
        if (isElementFullInViewport($('.slider-right-border')[i])) {
            $('.slider-right-border')[i].classList.add("white-border-right");
        }
    }

    for (var i = 0; i < $('.translate').length; i++) {
        if (isElementFullInViewport($('.translate')[i])) {
            $('.translate')[i].classList.add("translate-out");
        }
    }
  }

    
  window.addEventListener("load", callbackFunc);
  window.addEventListener("scroll", callbackFunc);



// WEBPACK FOOTER //
// ./wp/wp-content/themes/brockmeyer-chisel/src/scripts/additional/waypoints-full.js